import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import C2bLandingAtfForm from "../../../au-c2b/au.desktop/components/c2b-landing-atf-form";
import { PAGE_SOURCE } from "../../../constants/app-constants";

const PLACEHOLDER_TEXTS = {
    year: "Year",
    state: "State",
    rego: "Enter Rego"
};

const TradeInOrSellCarClpBanner = ({
    guestLoginProps
}) => {
    return (
        <div styleName={"styles.outer"}>
            <p styleName={"styles.heading"}>Got a car to sell or trade in? Get a free valuation instantly.</p>
            <C2bLandingAtfForm
                guestLoginProps={guestLoginProps}
                showVinToggleSection={false}
                checkVinActive={false}
                ctaText="Get valuation"
                eventId="CLP_REGO_FORM"
                formSource={PAGE_SOURCE.CLP}
                customStyles="clpInputStyle"
                customDropDownStyle="clpDropDownStyle"
                placeHolderText={PLACEHOLDER_TEXTS}
            />

        </div>
    );
};
TradeInOrSellCarClpBanner.propTypes = {
    guestLoginProps: PropTypes.object
};

export default TradeInOrSellCarClpBanner;
